import { render } from "./Clock.vue?vue&type=template&id=1742ccd0"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
script.render = render

export default script